import { Text, Tooltip } from "@fluentui/react-components";
import { FC, isValidElement, ReactNode } from "react";
import { customTokens, customTypographyStyles } from "../../theme/theme";
import { useBreakpoints } from "../../hooks";

interface ITypography {
  variant: keyof typeof customTypographyStyles;
  mobileVariant?: keyof typeof customTypographyStyles;
  tabletVariant?: keyof typeof customTypographyStyles;
  children: ReactNode;
  className?: string;
  color?: string;
  isHeading?: boolean;
  onClick?: () => void;
  showTooltip?: boolean;
  tooltipText?: string;
}

const Typography: FC<ITypography> = ({
  variant = "display2",
  mobileVariant,
  tabletVariant,
  children,
  className,
  color = customTokens.colorNeutralForeground1,
  isHeading = false,
  onClick,
  showTooltip = false,
  tooltipText = "",
}) => {
  const { isMobile, isTablet } = useBreakpoints();

  let style: any = { ...customTypographyStyles[variant] };

  if (isMobile && mobileVariant) {
    style = { ...customTypographyStyles[mobileVariant] };
  } else if (isTablet && tabletVariant) {
    style = { ...customTypographyStyles[tabletVariant] };
  }

  if (color) {
    style.color = color;
  }

  let content: ReactNode = children;

  if (isHeading) {
    if (typeof children === "string" && children.trim().endsWith(".")) {
      const textWithoutDot = children.trim().slice(0, -1);
      content = (
        <>
          {textWithoutDot}
          <span style={{ color: customTokens.UNFCCCPrimaryAccent100 }}>.</span>
        </>
      );
    } else if (
      isValidElement(children) &&
      typeof children.props.children === "string"
    ) {
      const text = children.props.children.trim();
      if (text.endsWith(".")) {
        const textWithoutDot = text.slice(0, -1);
        content = (
          <>
            {textWithoutDot}
            <span style={{ color: customTokens.UNFCCCPrimaryAccent100 }}>
              .
            </span>
          </>
        );
      }
    }
  }

  return (
    <>
      {showTooltip ? (
        <Tooltip content={tooltipText} relationship="description">
          <Text style={style} className={className} onClick={onClick}>
            {content}
          </Text>
        </Tooltip>
      ) : (
        <Text style={style} className={className} onClick={onClick}>
          {content}
        </Text>
      )}
    </>
  );
};

export default Typography;
